// extracted by mini-css-extract-plugin
export default {"main":"MessageComponent_main__DxyNn"};